import { supabase } from '@/lib/supabase';

type Props = {
  projectId: number;
  orgMemberId: string;
};

export const deleteProjectMember = async ({
  projectId,
  orgMemberId,
}: Props) => {
  const { error: memberError } = await supabase
    .from('project_members')
    .delete()
    .eq('project_id', projectId)
    .eq('org_member_id', orgMemberId);
  if (memberError) throw memberError;

  const { error: inviteError } = await supabase
    .from('project_member_invites')
    .delete()
    .eq('project_id', projectId)
    .eq('org_member_id', orgMemberId);
  if (inviteError) throw inviteError;
};
